import { Injectable } from '@angular/core';
import { Applications } from '../interfaces/application';
import { ImportFileCsv } from '../interfaces/importFileCsv';
import { ImportFileCsvCreate } from '../interfaces/importFileCsvCreate';

@Injectable({ providedIn: 'root' })
export class UtilService {
  magicNumber = 2;
  onDisplayApplications(application: Applications[]): string {
    let resultat = '';
    if (application.length > this.magicNumber) {
      for (let index = 0; index < this.magicNumber; index++) {
        resultat += application[index].name + ', ';
      }
      return resultat.substring(0, resultat.length - 1) + ' ... ';
    } else {
      application.forEach((element) => {
        resultat += element.name + ', ';
      });
      return resultat.substring(0, resultat.length - this.magicNumber);
    }
  }

  getTableRowStatusIcon(tableRowStatus: string): string {
    return {
      'verif': 'edit',
      'blocked': 'hourglass_empty',
      'actif': 'check_circle',
      'processing': 'info',
      'error': 'error',
      'OK': 'verified',
      'KO': 'dangerous',
      'HELP': 'help_center',
      'in progress': 'sync_disabled',
      'DONE': 'verified'
    }[tableRowStatus];
  }
  getTableRowStatusLabel(tableRowStatus: string): string {
    return { verif: 'Verif', blocked: 'Blocked', actif: 'Actif', processing: 'Processing', error: 'Error' }[tableRowStatus];
  }

  convertImortFileCsvToImportFilceCreate(importFileCsv: ImportFileCsv): ImportFileCsvCreate {
    const importFileCsvCreate: ImportFileCsvCreate = {
      targetName: importFileCsv.targetName,
      delimiter: importFileCsv.delimiter,
      header: importFileCsv.header,
      append: importFileCsv.append,
      connectionDBId: importFileCsv.connectionDB.id,
      columnCsvList: [
        {
          name: 'string',
          nullable: false,
          controllerId: 0
        }
      ]
    };
    importFileCsv.columnCsvList.forEach((item) => {
      importFileCsvCreate.columnCsvList.push({
        name: item.name,
        controllerId: item.controller.id,
        nullable: item.nullable
      });
    });
    return importFileCsvCreate;
  }

  methodTest(date: Date): string {
    return date.toString().slice(0, 10);
  }
}
